import UsersList from '../../modules/Users/UsersList/UsersList'

export default function UsersScreen() {
    
    return (
        <>
            <UsersList/>
        </>
    );
}